import { useSwiperSlide } from "swiper/react";
import {
  audio_correct,
  audio_incorrect,
  audio_click,
} from "../lib/SoundManager";
import React, { useRef, useState, useEffect } from "react";
import {
  atom,
  useRecoilState,
  useSetRecoilState,
  useRecoilValue,
} from "recoil";
import DragItem from "./DragItem";
import { useDrop, useDragLayer } from "react-dnd";
import { scaleAtom } from "./../App";

const Q1_DragItem = [
  {
    id: "q1_1",
    index: 1,
    value: "1",
    url: "images/03/02/q1_1.png",
    style: {
      position: "absolute",
      top: "729px",
      left: "311px",
    },
  },
  {
    id: "q1_2",
    index: 0,
    value: "2",
    url: "images/03/02/q1_2.png",
    style: {
      position: "absolute",
      top: "729px",
      left: "584px",
    },
  },
  {
    id: "q1_3",
    index: 2,
    value: "3",
    url: "images/03/02/q1_3.png",
    style: {
      position: "absolute",
      top: "729px",
      left: "854px",
    },
  },
];

const Q2_DragItem = [
  {
    id: "q2_1",
    index: 4,
    value: "1",
    url: "images/03/02/q2_1.png",
    style: {
      position: "absolute",
      top: "744px",
      left: "251px",
    },
  },
  {
    id: "q2_2",
    index: 5,
    value: "2",
    url: "images/03/02/q2_2.png",
    style: {
      position: "absolute",
      top: "744px",
      left: "552px",
    },
  },
  {
    id: "q2_3",
    index: 3,
    value: "3",
    url: "images/03/02/q2_3.png",
    style: {
      position: "absolute",
      top: "744px",
      left: "854px",
    },
  },
];

const refreshStatus = atom({
  key: "threetwo",
  default: false,
});

const refreshGuideStatus = atom({
  key: "refreshGuide-3-2",
  default: {
    display: false,
    target: "",
  },
});

export { refreshGuideStatus, refreshStatus };

export default function App() {
  const [refrsh] = useRecoilState(refreshStatus);
  const setRefreshGuide = useSetRecoilState(refreshGuideStatus);
  const scale = useRecoilValue(scaleAtom);
  const swiperSlide = useSwiperSlide();
  const [stage, setStage] = useState(0);
  const [stageDisplay, setStageDisplay] = useState(["block", "none"]);
  const [answer, setAnswer] = useState();
  const [answerDisplay, setAnswerDisplay] = useState([
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
  ]);
  const [naviDisplay, setNaviDisplay] = useState(["none", "block"]);
  const [clickGuideDisplay, setClickGuideDisplay] = useState("block");

  const question = useRef();

  const navi_q1 = useRef();
  const navi_q2 = useRef();

  const click_guide = useRef();

  const [{}, drop1] = useDrop(() => ({
    accept: "image",
    drop: (item) => dropHandler(item, "2"),
  }));

  const [{}, drop2] = useDrop(() => ({
    accept: "image",
    drop: (item) => dropHandler(item, "1"),
  }));

  const [{}, drop3] = useDrop(() => ({
    accept: "image",
    drop: (item) => dropHandler(item, "3"),
  }));

  const [{}, drop4] = useDrop(() => ({
    accept: "image",
    drop: (item) => dropHandler(item, "3"),
  }));

  const [{}, drop5] = useDrop(() => ({
    accept: "image",
    drop: (item) => dropHandler(item, "1"),
  }));

  const [{}, drop6] = useDrop(() => ({
    accept: "image",
    drop: (item) => dropHandler(item, "2"),
  }));

  let incorrect_count = 0;
  const dropHandler = (item, value) => {
    if (item.value == value) {
      audio_correct();

      setAnswer(item.index);

      setRefreshGuide({
        display: true,
        target: "3-2",
      });
    } else {
      audio_incorrect();
      incorrect_count++;

      if (incorrect_count == 5) {
        incorrect_count = 0;

        setAnswerDisplay([
          "block",
          "block",
          "block",
          "block",
          "block",
          "block",
        ]);
      }
    }
  };

  const onClickNavi = (obj) => {
    audio_click();
    let currentStage = stage;

    switch (obj.target.id) {
      case "next":
        if (currentStage < stageDisplay.length - 1) {
          currentStage++;

          setStage(currentStage);
          setNaviDisplay(["block", "none"]);
          setClickGuideDisplay("none");
        }
        break;
      case "prev":
        if (currentStage > 0) {
          currentStage--;

          setStage(currentStage);
          setNaviDisplay(["none", "block"]);
          setClickGuideDisplay("block");
        }
        break;
    }
  };

  const onRefresh = () => {
    if (document.readyState == "complete") {
      setStage(0);
      setAnswerDisplay(["none", "none", "none", "none", "none", "none"]);
      setNaviDisplay(["none", "block"]);
      setClickGuideDisplay("block");

      setRefreshGuide({
        display: false,
        target: "3-2",
      });
    }
  };

  useEffect(() => {
    if (answer != undefined) {
      let currentAnswerDisplay = answerDisplay;
      currentAnswerDisplay[answer] = "block";
      setAnswerDisplay([...currentAnswerDisplay]);
    }
  }, [answer]);

  useEffect(() => {
    let currentStageDisplay = stageDisplay;

    currentStageDisplay.forEach(function (item, index) {
      currentStageDisplay[index] = "none";
    });

    currentStageDisplay[stage] = "block";

    setStageDisplay([...currentStageDisplay]);
  }, [stage]);

  useEffect(() => {
    onRefresh();
  }, [refrsh]);

  if (!swiperSlide.isActive) {
    return <></>;
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        // backgroundImage: "url(images/03/02/guide.png)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
        }}
      >
        <div
          style={{
            display: stageDisplay[0],
          }}
        >
          <img
            style={{
              position: "absolute",
              top: "41px",
              left: "129px",
            }}
            src="images/03/02/subtitle1.png"
          ></img>

          <img
            ref={question}
            style={{
              position: "absolute",
              top: "140px",
              left: "125px",
            }}
            src="images/03/02/q1.png"
          ></img>
          {Q1_DragItem.map((example) => {
            return (
              <DragItem
                key={example.id}
                url={example.url}
                style={example.style}
                id={example.id}
                value={example.value}
                index={example.index}
                scale={scale}
              />
            );
          })}

          <div
            ref={drop1}
            style={{
              position: "absolute",
              top: "265px",
              left: "217px",
              width: "180px",
              height: "50px",
              zIndex: "1",
            }}
          ></div>

          <div
            ref={drop2}
            style={{
              position: "absolute",
              top: "315px",
              left: "246px",
              width: "180px",
              height: "50px",
              zIndex: "1",
            }}
          ></div>

          <div
            ref={drop3}
            style={{
              position: "absolute",
              top: "510px",
              left: "210px",
              width: "180px",
              height: "50px",
              zIndex: "1",
            }}
          ></div>

          <div>
            {answerDisplay[0] == "block" &&
              answerDisplay[1] == "block" &&
              answerDisplay[2] == "block" && (
                <img
                  src="images/03/02/img_o.png"
                  style={{
                    position: "absolute",
                    top: "340px",
                    left: "570px",
                  }}
                />
              )}
          </div>

          <div>
            <img
              src="images/03/02/answer-item1.png"
              style={{
                position: "absolute",
                top: "271px",
                left: "219px",
                display: answerDisplay[0],
              }}
            />
            <img
              src="images/03/02/answer-item2.png"
              style={{
                position: "absolute",
                top: "320px",
                left: "250px",
                display: answerDisplay[1],
              }}
            />
            <img
              src="images/03/02/answer-item3.png"
              style={{
                position: "absolute",
                top: "514px",
                left: "216px",
                display: answerDisplay[2],
              }}
            />
          </div>
        </div>

        <div
          style={{
            display: stageDisplay[1],
          }}
        >
          <img
            style={{
              position: "absolute",
              top: "35px",
              left: "155px",
            }}
            src="images/03/02/subtitle2.png"
          ></img>

          <img
            ref={question}
            style={{
              position: "absolute",
              top: "140px",
              left: "125px",
            }}
            src="images/03/02/q2.png"
          ></img>
          {Q2_DragItem.map((example) => {
            return (
              <DragItem
                key={example.id}
                url={example.url}
                style={example.style}
                id={example.id}
                value={example.value}
                index={example.index}
                scale={scale}
              />
            );
          })}

          <div
            ref={drop4}
            style={{
              position: "absolute",
              top: "377px",
              left: "394px",
              width: "255px",
              height: "50px",
              zIndex: "1",
            }}
          ></div>

          <div
            ref={drop5}
            style={{
              position: "absolute",
              top: "608px",
              left: "304px",
              width: "255px",
              height: "50px",
              zIndex: "1",
            }}
          ></div>

          <div
            ref={drop6}
            style={{
              position: "absolute",
              top: "656px",
              left: "304px",
              width: "255px",
              height: "50px",
              zIndex: "1",
            }}
          ></div>

          <div>
            {answerDisplay[3] == "block" &&
              answerDisplay[4] == "block" &&
              answerDisplay[5] == "block" && (
                <img
                  src="images/03/03/img_o.png"
                  style={{
                    position: "absolute",
                    top: "340px",
                    left: "570px",
                    zIndex: "2",
                  }}
                />
              )}
          </div>

          <div>
            <img
              src="images/03/02/answer-item4.png"
              style={{
                position: "absolute",
                top: "382px",
                left: "398px",
                display: answerDisplay[3],
              }}
            />
            <img
              src="images/03/02/answer-item5.png"
              style={{
                position: "absolute",
                top: "613px",
                left: "312px",
                display: answerDisplay[4],
              }}
            />
            <img
              src="images/03/02/answer-item6.png"
              style={{
                position: "absolute",
                top: "659px",
                left: "312px",
                display: answerDisplay[5],
              }}
            />
          </div>
        </div>

        <img
          onClick={onClickNavi}
          id="prev"
          ref={navi_q1}
          style={{
            position: "absolute",
            top: "842px",
            left: "125px",
            display: naviDisplay[0],
          }}
          src="images/03/02/navi_q1.png"
        ></img>

        <img
          onClick={onClickNavi}
          id="next"
          ref={navi_q2}
          style={{
            position: "absolute",
            top: "842px",
            left: "986px",
            display: naviDisplay[1],
          }}
          src="images/03/02/navi_q2.png"
        ></img>

        <img
          ref={click_guide}
          style={{
            position: "absolute",
            top: "780px",
            left: "1205px",
            zIndex: "2",
            display: clickGuideDisplay,
          }}
          src="images/03/02/click_guide.png"
        ></img>
      </div>
    </div>
  );
}
